module.exports = __webpack_public_path__ + "static/media/external-link-icon.7ec190a1.svg";